import styled from 'styled-components';

import SvgIcon from '../../SvgIcon';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: row;
`;

export const ActionHeader = styled.h3`
  margin: 15px 0;
  font-size: 21px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.red.a10};
  width: 15rem;
`;

export const ActionContent = styled.span`
  font-size: 15px;
  line-height: 1.73;
  color: ${({ theme }) => theme.baseBlue.a6};
  width: 25rem;
`;

export const ButtonMargin = styled.div`
  margin-right: 15px;
`;

export const ActionErrorMsg = styled.div`
  color: ${({ theme }) => theme.red.a10};
  margin-top: 15px;
`;

export const IconContainer = styled(SvgIcon)`
  display: block;
  color: ${({ theme }) => theme.red.a10};
`;

export const ActionInputLabel = styled.span`
  margin-top: 30px;
  font-weight: 600;
`;

export const InputWrapper = styled.div`
  width: 100%;
  margin-top: 15px;
`;
